import * as React from "react";
import { Fab, List } from "@material-ui/core";
import { Save as SaveIcon } from "@material-ui/icons";
import ListItemSwitch from "screens/components/ListItemSwitch";
import CardFlex from "screens/components/CardFlex";
import { useOrg, useApiClient } from "lib/store";
import { useErrorHandler } from "../../ErrorHandler";
import { Form } from "lib";

interface Props {
  className?: string;
}

const Commande: React.FC<Props> = ({ className }) => {
  const api = useApiClient();
  const org = useOrg();
  const [loading, setLoading] = React.useState(false);
  const [showSource, setShowSource] = React.useState(false);
  const [sortLivraisonReverse, setSortLivraisonReverse] = React.useState(false);
  const [pickingPrintOrders, setPickingPrintOrders] = React.useState(false);
  const [pickingShowMissingPlaces, setPickingShowMissingPlaces] =
    React.useState(true);
  const [pickingShowMissingRefs, setPickingShowMissingRefs] =
    React.useState(true);
  const errorHandler = useErrorHandler();

  React.useEffect(() => {
    setShowSource(org.config.orders.showSource);
    setSortLivraisonReverse(org.config.orders.sortLivraisonReverse);
    setPickingPrintOrders(org.config.orders.pickingPrintOrders);
    setPickingShowMissingRefs(org.config.orders.pickingShowMissingRefs);
    setPickingShowMissingPlaces(org.config.orders.pickingShowMissingPlaces);
  }, [org]);

  function handleSave() {
    setLoading(true);
    api
      .PUT("/api/orgs/{org}/orders", {
        params: {
          path: {
            org: org.org,
          },
        },
        body: {
          showSource,
          sortLivraisonReverse,
          pickingPrintOrders,
          pickingShowMissingPlaces,
          pickingShowMissingRefs,
        },
      })
      .catch(errorHandler)
      .finally(() => {
        setLoading(false);
      });
  }

  const actions = (
    <Fab
      color="primary"
      size="small"
      onClick={handleSave}
      aria-label="Enregistrer"
    >
      <SaveIcon />
    </Fab>
  );

  return (
    <CardFlex title="Commandes" actions={actions} loading={loading}>
      <List>
        <ListItemSwitch
          label="Afficher la source des commandes"
          checked={Boolean(showSource)}
          onChange={Form.handleChangeCheck(setShowSource)}
        />
        <ListItemSwitch
          label="Inverser ordre tri livraison"
          checked={Boolean(sortLivraisonReverse)}
          onChange={Form.handleChangeCheck(setSortLivraisonReverse)}
        />
        <ListItemSwitch
          label="Picking : Imprimer les commandes"
          checked={Boolean(pickingPrintOrders)}
          onChange={Form.handleChangeCheck(setPickingPrintOrders)}
        />
        <ListItemSwitch
          label="Picking : Afficher références inconnues"
          checked={Boolean(pickingShowMissingRefs)}
          onChange={Form.handleChangeCheck(setPickingShowMissingRefs)}
        />
        <ListItemSwitch
          label="Picking : Afficher emplacements inconnus"
          checked={Boolean(pickingShowMissingPlaces)}
          onChange={Form.handleChangeCheck(setPickingShowMissingPlaces)}
        />
      </List>
    </CardFlex>
  );
};

export default Commande;
